import * as api from '../../../clients/incidents';

import {Action} from '@ngrx/store';

export const GET_INCIDENT_VORLAGEN_LISTE_ADMIN = '[IncidentsModul] GetIncidentVorlagenListeAdmin laden';
export const GET_INCIDENT_VORLAGEN_LISTE_ADMIN_AUSFUEHREN = '[IncidentsModul] GetIncidentVorlagenListeAdmin ausführen';
export const GET_INCIDENT_VORLAGEN_LISTE_ADMIN_ERFOLGREICH = '[IncidentsModul] GetIncidentVorlagenListeAdmin laden erfolgreich';
export const GET_INCIDENT_VORLAGEN_LISTE_ADMIN_FEHLER = '[IncidentsModul] GetIncidentVorlagenListeAdmin Ladefehler';
export const GET_INCIDENT_VORLAGEN_LISTE_ADMIN_NICHT_AUSGEFUEHRT = '[IncidentsModul] GetIncidentVorlagenListeAdmin nicht ausgeführt (evtl. Offline)';


export class GetIncidentVorlagenListeAdminAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ADMIN;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeAdminAusfuehrenAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ADMIN_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeAdminErfolgreichAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ADMIN_ERFOLGREICH;
        constructor(public payload: Array<api.IncidentVorlage>, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeAdminFehlerAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ADMIN_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetIncidentVorlagenListeAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_INCIDENT_VORLAGEN_LISTE_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type IncidentsQueryIncidentVorlagenListeAdminActions =
    GetIncidentVorlagenListeAdminAction
    | GetIncidentVorlagenListeAdminAusfuehrenAction
    | GetIncidentVorlagenListeAdminErfolgreichAction
    | GetIncidentVorlagenListeAdminFehlerAction
    | GetIncidentVorlagenListeAdminNichtAusgefuehrtAction
    ;
